import {CLIENT_COUPONS_CA} from './siteIds'

const config = {
  clientId: CLIENT_COUPONS_CA,
  clientUrl: 'https://www.Coupons.ca/',
  privacyPolicyUrl: 'https://www.coupons.ca/privacy-policy',
  termsUrl: 'https://www.coupons.ca/privacy-policy',
  appName: 'Coupons.ca',
  siteName: 'Coupons.ca',
  price: 24.99,
  currency: 'CAD',
  currencySymbol: 'CA$',
  primaryColor: 'red',
  outlineFocusColor: 'focus:outline-green-500',
  bgColor: 'bg-green-500',
  hoverColor: 'bg-green-500',
  focusVisibleColor: `focus-visible:outline-green-500`,
  textColor: `text-green-500`,
  hoverTextColor: `hover:text-green-400`,
  brands: [
    {
      name: 'athleta-ca',
      logo: '/popular-brands/athleta-ca-coupons.png',
    },
    {
      name: 'banana-republic',
      logo: '/popular-brands/banana-republic-coupons.png',
    },
    {
      name: 'columbia-sportswear',
      logo: '/popular-brands/columbia-sportswear-coupons.png',
    },
    {
      name: 'cupshe',
      logo: '/popular-brands/cupshe-coupons.png',
    },
    {
      name: 'little-burgundy',
      logo: '/popular-brands/little-burgundy-coupons.png',
    },
    {
      name: 'peoples-jewellers',
      logo: '/popular-brands/peoples-jewellers-coupons.png',
    },
    {name: 'rona', logo: '/popular-brands/rona-coupons.png'},
    {name: 'vitamix', logo: '/popular-brands/vitamix-coupons.png'},
    {
      name: 'the-shopping-channel',
      logo: '/popular-brands/the-shopping-channel-coupons.png',
    },
    {name: 'expedia', logo: '/popular-brands/expedia-coupons.png'},
  ],
}
export default config
